import styles from './login1.module.css';
import { useState } from 'react';

// The React Functional Component
export const Login1 = () => {
  // A simple state to toggle password visibility (optional, but good practice)
  const [showPassword, setShowPassword] = useState(false);

  // You would handle the form submission logic here (e.g., const handleSubmit = (e) => {...})

  return (
    // Equivalent to the body's wrapper div
    <div className={`${styles.container} light`}> 
      {/* Background map layer */}
      <div className={styles.bgMapOverlay}></div> 

      {/* Content wrapper */}
      <div className={styles.contentWrapper}> 
     

        <main className={styles.mainCard}>
          <div className={styles.cardHeader}>
            <h1 className={styles.cardTitle}>Sign In</h1>
            <p className={styles.cardSubtitle}>Welcome back! Please enter your details.</p>
          </div>
          
          <form className={styles.form} onSubmit={(e) => e.preventDefault()}>
            
            {/* Email Field */}
            <div className={styles.formGroup}>
              <label className={styles.label} htmlFor="email">Email Address</label>
              <div className={styles.inputWrapper}>
                <span className={`${styles.icon} material-symbols-outlined`}>mail</span>
                <input 
                  className={styles.input} 
                  id="email" 
                  placeholder="you@company.com" 
                  type="email" 
                  defaultValue="" // Use defaultValue in React for pre-filled forms if not using state
                />
              </div>
            </div>

            
            
            {/* Password Field */}
            <div className={styles.formGroup}>
              <label className={styles.label} htmlFor="password">Password</label>
              <div className={styles.inputWrapper}>
                <span className={`${styles.icon} material-symbols-outlined`}>lock</span>
                <input 
                  className={styles.input} 
                  id="password" 
                  placeholder="••••••••" 
                  type={showPassword ? "text" : "password"} 
                  defaultValue=""
                />
                <button 
                  className={styles.togglePasswordButton} 
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <span className={`${styles.icon} material-symbols-outlined`}>{showPassword ? 'visibility' : 'visibility_off'}</span>
                </button>
              </div>
            </div>
            
            {/* Remember Me / Forgot Password */}
            <div className={styles.actionsBar}>
              <label className={styles.checkboxLabel}>
                <input className={styles.checkbox} type="checkbox"/>
                <span className={styles.checkboxText}>Remember me</span>
              </label>
              <a className={styles.forgotPasswordLink} href="#">Forgot Password?</a>
            </div>
            
            {/* Login Button */}
            <button className={styles.loginButton} type="submit">
              <span className={styles.buttonText}>Login</span>
            </button>
          </form>

          {/* Sign Up Link */}
          <p className={styles.signUpText}>
            Don&apos;t have an account? <a className={styles.signUpLink} href="#">Sign Up</a>
          </p>
        </main>

        {/* Footer */}
      
      </div>
    </div>
  );
};